import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "ss-card ss-card-space"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"ant-row\"><div class=\"ant-col ant-col-xs-8 ant-col-xl-2\"><span class=\"ss-titulo-coluna\">Posição</span></div><div class=\"ant-col ant-col-xs-8 ant-col-xl-6 ss-apresentar-inicio\"><span class=\"ss-titulo-coluna\">Coluna</span></div><div class=\"ant-col ant-col-xs-8 ant-col-xl-2\"><span class=\"ss-titulo-coluna\">Visível</span></div><div class=\"ant-col ant-col-xs-8 ant-col-xl-3\"><span class=\"ss-titulo-coluna\">Fixar</span></div><div class=\"ant-col ant-col-xs-8 ant-col-xl-3\"><span class=\"ss-titulo-coluna\">Alinhamento</span></div><div class=\"ant-col ant-col-xs-8 ant-col-xl-4\"><span class=\"ss-titulo-coluna\">Tamanho</span></div></div>", 1)
const _hoisted_3 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_4 = {
  href: "#",
  class: "handle"
}
const _hoisted_5 = { class: "ant-col ant-col-xs-18 ant-col-xl-6 ss-apresentar-inicio" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "ant-col ant-col-xs-4 ant-col-xl-2" }
const _hoisted_9 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_10 = { class: "ant-col ant-col-xs-12 ant-col-xl-3" }
const _hoisted_11 = { class: "ant-col ant-col-xs-12 ant-col-xl-6" }
const _hoisted_12 = { class: "ant-col ant-col-xs-12 ant-col-xl-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_slider = _resolveComponent("a-slider")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_draggable = _resolveComponent("draggable")!

  return (_ctx.tela.computedVisivel)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_draggable, {
          modelValue: _ctx.tela.computedColunas,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tela.computedColunas) = $event)),
          "item-key": "id",
          handle: ".handle"
        }, {
          item: _withCtx(({element}) => [
            (element.title !== 'Código')
              ? (_openBlock(), _createElementBlock("div", {
                  key: element.key,
                  class: "ant-row ss-contorno"
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("a", _hoisted_4, [
                      _createVNode(_component_icone, { nome: "draggable" })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    (element.title !== undefined)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(element.title), 1))
                      : _createCommentVNode("", true),
                    (element.presentation !== undefined)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(element.presentation), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    (element.title === 'Código')
                      ? (_openBlock(), _createBlock(_component_a_switch, {
                          key: 0,
                          checked: false,
                          "checked-children": "Sim",
                          "un-checked-children": "Não"
                        }))
                      : (_openBlock(), _createBlock(_component_a_switch, {
                          key: 1,
                          checked: element.visible,
                          "onUpdate:checked": ($event: any) => ((element.visible) = $event),
                          "checked-children": "Sim",
                          "un-checked-children": "Não"
                        }, null, 8, ["checked", "onUpdate:checked"]))
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_select, {
                      placeholder: "Não",
                      value: element.fixed,
                      "onUpdate:value": ($event: any) => ((element.fixed) = $event),
                      style: {"width":"90%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Não ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "left" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Esquerda ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "right" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Direita ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["value", "onUpdate:value"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_a_select, {
                      placeholder: "Defina",
                      value: element.align,
                      "onUpdate:value": ($event: any) => ((element.align) = $event),
                      style: {"width":"90%"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_select_option, { value: "left" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Esquerda ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Centro ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_select_option, { value: "right" }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Direita ")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["value", "onUpdate:value"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_slider, {
                      value: element.width,
                      "onUpdate:value": ($event: any) => ((element.width) = $event),
                      min: 10,
                      max: 1000,
                      style: {"margin-left":"20px","margin-right":"20px"}
                    }, null, 8, ["value", "onUpdate:value"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_input_number, {
                      placeholder: "Automático",
                      min: 10,
                      max: 1000,
                      value: element.width,
                      "onUpdate:value": ($event: any) => ((element.width) = $event)
                    }, null, 8, ["value", "onUpdate:value"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]))
    : _createCommentVNode("", true)
}